import { LazyLog, ScrollFollow } from 'react-lazylog';
import * as React from "react";
import {identityServerWS, IDPoolContext} from "../Context/IDContext";
import {useContext} from "react";
const LazyLogComponent = LazyLog as unknown as React.ComponentType<any>;

export function BurnInLogs() {
    const { accessToken } = useContext(IDPoolContext)
    let ws_protocol = "ws://"
    if (window.location.protocol === "https:") {
        ws_protocol = "wss://"
    }

    return (  <LazyLogComponent url={ws_protocol+identityServerWS+"/stream/burnin?access_token="+accessToken} enableSearch websocket={true} follow={true} height="600" width="600" />)
}